<template>
  <div v-show="false" />
</template>

<script>
import { defineComponent, useMeta } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'LocalBusiness',
  head: {},
  setup() {
    const LocalBusinessData = {
      '@context': 'https://schema.org',
      '@type': 'FurnitureStore',
      name: 'Sogni di Cristallo',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Mirano, Venezia',
        addressRegion: 'IT',
        postalCode: '30035',
        streetAddress: 'Via Castellantico, 17',
        telephone: '+39 041 4762538',
      },
    };
    useMeta(() => ({
      script: [
        {
          innerHTML: JSON.stringify(LocalBusinessData),
          type: 'application/ld+json',
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
    }));
  },
});
</script>
